import script from "./AnaliseNoticiasPrex.vue?vue&type=script&setup=true&lang=js"
export * from "./AnaliseNoticiasPrex.vue?vue&type=script&setup=true&lang=js"

import "./AnaliseNoticiasPrex.vue?vue&type=style&index=0&id=77500d44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77500d44"]])

export default __exports__